import {apiWithToken} from '../../../systems/api/index';
import {API_URL} from '../../../systems/globalContant/index';

export default {
    getListTransactionFile: (filters) => apiWithToken.get(API_URL.LIST_TRANSACTION_FILE, {params: filters}, {loading: false}),
    downloadFile: (data) => apiWithToken.get(API_URL.DOWNLOAD_TRANSACTION_FILE + data.id, {}, {loading: false}),
};